module.exports = __webpack_public_path__ + "media/images/next-1ef4b8c7b522adacf7c55fae75caac6c.png";